import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1646d871 = () => interopDefault(import('../pages/local.vue' /* webpackChunkName: "" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ar",
    component: _1646d871,
    alias: "/",
    name: "local___ar"
  }, {
    path: "/co",
    component: _1646d871,
    alias: "/",
    name: "local___co"
  }, {
    path: "/de",
    component: _1646d871,
    alias: "/",
    name: "local___de"
  }, {
    path: "/en",
    component: _1646d871,
    alias: "/",
    name: "local___en"
  }, {
    path: "/es",
    component: _1646d871,
    alias: "/",
    name: "local___es"
  }, {
    path: "/fr",
    component: _1646d871,
    alias: "/",
    name: "local___fr"
  }, {
    path: "/it",
    component: _1646d871,
    alias: "/",
    name: "local___it"
  }, {
    path: "/mx",
    component: _1646d871,
    alias: "/",
    name: "local___mx"
  }, {
    path: "/nl",
    component: _1646d871,
    alias: "/",
    name: "local___nl"
  }, {
    path: "/pt",
    component: _1646d871,
    alias: "/",
    name: "local___pt"
  }, {
    path: "/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs"
  }, {
    path: "/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index"
  }, {
    path: "/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings"
  }, {
    path: "/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints"
  }, {
    path: "/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile"
  }, {
    path: "/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index"
  }, {
    path: "/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences"
  }, {
    path: "/ar/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___ar"
  }, {
    path: "/ar/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___ar"
  }, {
    path: "/ar/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___ar"
  }, {
    path: "/ar/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___ar"
  }, {
    path: "/ar/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___ar"
  }, {
    path: "/ar/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___ar"
  }, {
    path: "/ar/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___ar"
  }, {
    path: "/co/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___co"
  }, {
    path: "/co/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___co"
  }, {
    path: "/co/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___co"
  }, {
    path: "/co/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___co"
  }, {
    path: "/co/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___co"
  }, {
    path: "/co/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___co"
  }, {
    path: "/co/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___co"
  }, {
    path: "/de/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___de"
  }, {
    path: "/de/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___de"
  }, {
    path: "/de/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___de"
  }, {
    path: "/de/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___de"
  }, {
    path: "/de/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___de"
  }, {
    path: "/de/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___de"
  }, {
    path: "/de/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___de"
  }, {
    path: "/en/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___en"
  }, {
    path: "/en/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___en"
  }, {
    path: "/en/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___en"
  }, {
    path: "/en/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___en"
  }, {
    path: "/en/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___en"
  }, {
    path: "/en/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___en"
  }, {
    path: "/en/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___en"
  }, {
    path: "/es/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___es"
  }, {
    path: "/es/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___es"
  }, {
    path: "/es/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___es"
  }, {
    path: "/es/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___es"
  }, {
    path: "/es/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___es"
  }, {
    path: "/es/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___es"
  }, {
    path: "/es/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___es"
  }, {
    path: "/fr/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___fr"
  }, {
    path: "/fr/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___fr"
  }, {
    path: "/fr/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___fr"
  }, {
    path: "/fr/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___fr"
  }, {
    path: "/fr/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___fr"
  }, {
    path: "/fr/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___fr"
  }, {
    path: "/fr/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___fr"
  }, {
    path: "/it/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___it"
  }, {
    path: "/it/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___it"
  }, {
    path: "/it/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___it"
  }, {
    path: "/it/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___it"
  }, {
    path: "/it/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___it"
  }, {
    path: "/it/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___it"
  }, {
    path: "/it/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___it"
  }, {
    path: "/mx/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___mx"
  }, {
    path: "/mx/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___mx"
  }, {
    path: "/mx/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___mx"
  }, {
    path: "/mx/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___mx"
  }, {
    path: "/mx/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___mx"
  }, {
    path: "/mx/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___mx"
  }, {
    path: "/mx/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___mx"
  }, {
    path: "/nl/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___nl"
  }, {
    path: "/nl/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___nl"
  }, {
    path: "/nl/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___nl"
  }, {
    path: "/nl/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___nl"
  }, {
    path: "/nl/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___nl"
  }, {
    path: "/nl/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___nl"
  }, {
    path: "/nl/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___nl"
  }, {
    path: "/pt/discovery/faqs",
    component: _2dfb1658,
    props: {"options":{"view":"faqs"},"pageId":{"dev":"368904","qa":"368904","uat":"368904","preview":"368904","prod":"368904"}},
    alias: "/discovery/faqs/",
    name: "faqs___pt"
  }, {
    path: "/pt/discovery/home",
    component: _2dfb1658,
    props: {"options":{"view":"home"},"pageId":{"dev":"368623","qa":"368623","uat":"368623","preview":"368623","prod":"368623"}},
    alias: "/discovery/home/",
    name: "index___pt"
  }, {
    path: "/pt/discovery/my-bookings",
    component: _2dfb1658,
    props: {"options":{"view":"myBookings"},"pageId":{"dev":"368694","qa":"368694","uat":"368694","preview":"368694","prod":"368694"}},
    alias: "/discovery/my-bookings/",
    name: "myBookings___pt"
  }, {
    path: "/pt/discovery/my-points",
    component: _2dfb1658,
    props: {"options":{"view":"myPoints"},"pageId":{"dev":"374234","qa":"374234","uat":"374234","preview":"374234","prod":"374234"}},
    alias: "/discovery/my-points/",
    name: "myPoints___pt"
  }, {
    path: "/pt/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "myProfile___pt"
  }, {
    path: "/pt/discovery/my-profile",
    component: _2dfb1658,
    props: {"options":{"view":"myProfile"},"pageId":{"dev":"368903","qa":"368903","uat":"368903","preview":"368903","prod":"368903"}},
    alias: "/discovery/my-profile/",
    name: "index___pt"
  }, {
    path: "/pt/discovery/preferences",
    component: _2dfb1658,
    props: {"options":{"view":"preferences"},"pageId":{"dev":"373552","qa":"373552","uat":"373552","preview":"373552","prod":"373552"}},
    alias: "/discovery/preferences/",
    name: "preferences___pt"
  }, {
    path: "/ar/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___ar"
  }, {
    path: "/co/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___co"
  }, {
    path: "/de/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___de"
  }, {
    path: "/discovery/my-bookings/management/",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement"
  }, {
    path: "/en/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___en"
  }, {
    path: "/es/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___es"
  }, {
    path: "/fr/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___fr"
  }, {
    path: "/it/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___it"
  }, {
    path: "/mx/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___mx"
  }, {
    path: "/nl/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___nl"
  }, {
    path: "/pt/discovery/my-bookings/management",
    component: _2dfb1658,
    props: {"options":{"view":"myBookingsLLManagement"},"pageId":{"dev":"378263","qa":"378263","uat":"378263","preview":"378263","prod":"378263"}},
    alias: "/discovery/my-bookings/management/",
    name: "myBookingsLLManagement___pt"
  }, {
    path: "/",
    component: _1646d871,
    alias: "/",
    name: "local"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
